import React from 'react';
import './AddressBox.scss';
import { useSelector } from 'react-redux';
import { TripState } from '../../types/trip.store.type';
import { TranslationUtils } from '../../utils';

export const AddressBox: React.FC = () => {
    const unit = useSelector((store: { trip: TripState }) => store.trip.unit);

    if (!unit) {
        return null;
    }

    const { address_1, address_2, city, state, country_code, latitude, longitude } = unit;

    return (
        <div className="address-box">
            <p aria-hidden className="body-small-bold  address-title">
                {TranslationUtils.get('address')}
            </p>
            <a
                role={'link'}
                aria-label={`${address_1}, ${city}, ${country_code} ${TranslationUtils.get('address')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="body-small address-link"
                href={`http://maps.google.com/maps?q=${latitude},${longitude}`}
                dangerouslySetInnerHTML={{
                    __html: `${address_1}<br/>${address_2 ? address_2 + '<br/>' : ''}${city}, ${state}, ${country_code}`,
                }}
            />
        </div>
    );
};
